module.exports = __webpack_public_path__ + "static/media/Roland.84f6fb74.jpeg";